var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-8"},[_c('viewReport',{attrs:{"report_id":_vm.$route.params.report_id}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }